import { ReviewSlider } from "modules/common/components/Trustpilot/ReviewSlider";
import type { ReactStoryblokComponent } from "types/storyblok";

const TrustpilotSliderAdapter = ({ sbEditable }: ReactStoryblokComponent<unknown>) => (
  <ReviewSlider sbEditable={sbEditable} />
);

export default TrustpilotSliderAdapter;
